<label class="form-label" for="name">{{ 'lang.globals.name' |translate }}</label>
<input id="name" name="name" class="form-control" [(ngModel)]="mediumGroupCategory.name">
<div class="my-2">{{ 'lang.globals.parent'|translate }}</div>
<sb-comp-dropdown-select
    [dropDownDatatype]="'MEDIUMGROUP_CATEGORIES'"
    [singleSelectMode]="true" [showSubmit]="false"
    [inputData]="mediumGroupCategories"
    (selectedDataEmitter)="update($event, 'MEDIUMGROUP_CATEGORIES')" [showColumnIcon]="false"
    [msOptions]="msCategoryOptions" (msOptionsChange)="msRequest('MEDIUMGROUP_CATEGORIES', $event)"
    [selectedInputData]="mediumGroupCategory.parent ? [mediumGroupCategory.parent] : []">
</sb-comp-dropdown-select>

<div class="d-flex justify-content-end mt-4">
  <button *ngIf="!isInModalContext" [disabled]="!mediumGroupCategory.name" (click)="saveClick.emit(true)" class="btn btn-primary">
    <sb-icon icon="save"></sb-icon>
    {{ 'lang.globals.save' |translate }}
  </button>
  <button *ngIf="isInModalContext" [disabled]="!mediumGroupCategory.name" (click)="modalNavigationService.result(mediumGroupCategory)"
          class="btn btn-primary">
    <sb-icon icon="save"></sb-icon>
    {{ 'lang.globals.save' |translate }}
  </button>
</div>
